import { IQuestionModel } from '@care-portals/api-interfaces';

const questionsModels: IQuestionModel[] = [
  /**
   * Epipen consult
   */
  {
    // 1 Pregnancy question
    label: 'Which epinephrine autoinjector do you prefer to use?',
    subLabel: '(Select the one you prefer)',
    field: 'epipenType',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'epipen', value: 'Epipen' },
        { key: 'allerjectFrench', value: 'Allerject French' },
        { key: 'allerjectEnglish', value: 'Allerject English' }
      ]
    }
  },
  {
    // 2
    label: 'What is your weight?',
    field: 'epiPenweight',
    type: 'info',
    answer: {
      type: 'measure',
      value: {
        type: 'number',
        name: 'value',
        placeholder: 'weight',
        size: 'large'
      },
      division: '&mdash;',
      unit: {
        type: 'dropdown',
        name: 'unit',
        options: [
          { key: 'lbs', value: 'lbs' },
          { key: 'kgs', value: 'kgs' }
        ],
        placeholder: 'unit',
        size: 'large'
      }
    }
  },
  {
    // 3
    label:
      'Where do you typically need to keep an autoinjector?',
    field: 'epipenLocation',
    type: 'select',
    answer: {
      type: 'multi_select',

      options: [
        { key: 'home', value: 'at home' },
        { key: 'school', value: 'at school' },
        { key: 'work', value: 'at work' },
        { key: 'daycare', value: 'at daycare' }
      ]
    }
  },

  {
    // 4
    field: 'epipenHowMany',
    label: 'How many autoinjectors do you have at home currently that are not expiring in the next 6 months ?',
    type: 'info',
    answer: {
    type: 'number',
    name: 'howmany'
  },
    
  },
  {
    // 5
    field: 'epipenMedicalReason',
    label: 'What is your medical reason for ordering an Epipen?',
    type: 'info',
    answer: {
    type: 'text',
    name: 'epipenMedicalReason'
  },
},

{
  // 6
  field: 'epipenLastUsed',
  label: 'When was the last time you used an Epipen?',
  type: 'info',
  answer: {
  type: 'text',
  name: 'epipenLastUsed'
},
},

  {
    // 7
    field: 'epipenHowManyLocations',
    label: 'How many autoinjectors do you need to cover the locations where you are required to keep an epipen?',
    type: 'info',
    answer: {
    type: 'number',
    name: 'howmanylocations'
  },
    
  },
  {
    field: 'epipenInsurance',
    label:
      'Does your insurance have a maximum on the number of epipens you are allowed per year?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'Yes',
          value:
            'Yes'
        },
        {
          key: 'No',
          value:
            'No'
        },
        {
          key: 'idk',
          value:
            'I don`t know'
        }

      ]
    }
  }
];

export default questionsModels;
